import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import { Analytics } from "@vercel/analytics/react"
import './App.css';
import Header from './Header';
import { Main } from './Main';
import Footer from './Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Main />
        <Footer />
      </div>
      <Analytics />
    </Router>
  );
}

export default App;